{
  "page": {
    "heading": "Notifications",
    "unreadBadge": "{{count}} unread"
  },
  "categories": {
    "all": "All",
    "orders": "Orders",
    "products": "Products",
    "stores": "Stores",
    "vendors": "Vendors",
    "billing": "Billing",
    "system": "System"
  },
  "filters": {
    "ariaLabel": "Filter notifications by category",
    "unreadOnly": "Unread only"
  },
  "actions": {
    "markAllRead": "Mark all as read",
    "markRead": "Mark as read",
    "dismiss": "Dismiss",
    "openDetail": "Open details",
    "loadMore": "Load more",
    "loadingMore": "Loading…"
  },
  "list": {
    "ariaLabel": "Notification feed"
  },
  "loading": "Loading notifications…",
  "empty": {
    "body": "No notifications."
  },
  "errors": {
    "load": "Failed to load notifications",
    "loadMore": "Failed to load more notifications",
    "markRead": "Failed to update",
    "dismiss": "Failed to dismiss notification",
    "markAllRead": "Failed to mark all as read"
  }
}